<template>
  <div class="spinner-section cell medium-2 large-2">
    <svg height="100%" width="100%" viewBox="8 10 180 180" aria-labelledby="loyalty-points">
      <title id="loyalty-points">{{ `${currentPoints || 0} loyalty points` }}</title>
      <path stroke="#EBEBEB" d="M41 149.5a77 77 0 1 1 117.93 0" fill="none" />
      <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="100%">
        <stop id="start" ref="start" offset="0%" />
        <stop id="stop" ref="stop" offset="100%" />
      </linearGradient>
      <path ref="meter" class="meter" stroke="#09c" d="M41 149.5a77 77 0 1 1 117.93 0" fill="none" stroke-dasharray="350" stroke-dashoffset="350" />
      <path ref="circle" fill="none" class="circle" d="M39 149.5a77 77 0 1 1 117.93 0" />
      <path ref="outerCircle" fill="none" class="outer-circle" d="M39 149.5a77 77 0 1 1 117.93 0" />
      <text x="55%" y="55%" text-anchor="middle" dy=".3em" class="points-to-next-award h1">{{ currentPoints || 0 }}</text>
    </svg>
    <div class="star-money small">1,000 pts = $10 Star Money</div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useDashboardStore } from '@/stores/useDashboardStore';

const dashboardStore = useDashboardStore();
const { rewardsSummary } = storeToRefs(dashboardStore);

const pointsThresholdForAward = computed(() => rewardsSummary.value?.rewardsInfo?.pointsThresholdForAward);
const currentPoints = computed(() => rewardsSummary.value?.rewardsInfo?.currentPoints);

const start = ref(null);
const stop = ref(null);
const meter = ref(null);
const circle = ref(null);
const outerCircle = ref(null);

const drawSpinner = () => {
  const meterPath = meter.value;
  const startEl = start.value;
  const stopEl = stop.value;
  const circlePath = circle.value;
  const outerCirclePath = outerCircle.value;
  const length = meterPath.getTotalLength();
  const tierName = (rewardsSummary.value?.tierInfo?.tierName || '').toLowerCase();

  if (tierName === 'gold') {
    startEl.setAttribute('stop-color', '#B19050');
    stopEl.setAttribute('stop-color', '#B19050');
    circlePath.style.stroke = '#B19050';
  }
  if (tierName === 'platinum') {
    startEl.setAttribute('stop-color', '#959499');
    stopEl.setAttribute('stop-color', '#959499');
    circlePath.style.stroke = '#959499';
  }
  if (tierName === 'silver') {
    startEl.setAttribute('stop-color', '#667479');
    stopEl.setAttribute('stop-color', '#667479');
    circlePath.style.stroke = '#667479';
  }
  if (tierName === 'bronze') {
    startEl.setAttribute('stop-color', '#924B2C');
    stopEl.setAttribute('stop-color', '#924B2C');
    circlePath.style.stroke = '#924B2C';
  }
  if (!tierName) {
    circlePath.style.stroke = '#924B2C';
    return;
  }
  if (currentPoints.value) {
    // Calculate the percentage of the total length
    const to = length * ((pointsThresholdForAward.value - currentPoints.value) / pointsThresholdForAward.value);
    // Trigger Layout in Safari
    meterPath.getBoundingClientRect();
    // Set the Offset
    meterPath.style.strokeDashoffset = Math.max(0, to);
    circlePath.style.strokeDashoffset = Math.max(0, to);
    outerCirclePath.style.strokeDashoffset = Math.max(0, to);
  }
};

onMounted(() => {
  drawSpinner();
});
</script>

<style lang="scss" brand="mcom" scoped>
@import '~settingSCSS';

.spinner-section {
  height: rem-calc(100);
  @include breakpoint(medium up) {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  @include breakpoint(small down) {
    width: rem-calc(138);
    height: rem-calc(96);
    text-align: left;
    padding-left: rem-calc(32);
  }

  svg {
    @include breakpoint(medium up) {
      overflow: visible;
    }
    max-width: rem-calc(105);
    margin-right: rem-calc(20);
  }
  svg path {
    stroke-width: rem-calc(15.15);
    transition: stroke-dashoffset 850ms ease-in-out;
    stroke-linecap: round;
  }
  path.meter {
    stroke: url(#gradient);
  }

  path.circle {
    stroke: #a5a4aa;
    stroke-dasharray: rem-calc(0), 349.5177;
    stroke-dashoffset: 349.5177;
    stroke-width: rem-calc(27);
    transform: rotateX('10');
  }

  path.outer-circle {
    stroke: #ffffff;
    stroke-dasharray: rem-calc(0), 349.5177;
    stroke-dashoffset: 349.5177;
    stroke-width: rem-calc(20);
  }

  .star-money {
    position: relative;
    bottom: rem-calc(15);
    text-align: center;
  }
}
</style>
